import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { EarlyAccessForm } from '../components/EarlyAccessForm';
import { ServicesPreview } from '../components/ServicesPreview';
import { WhoItIsFor } from '../components/WhoItIsFor';
import { WhyJoinEarly } from '../components/WhyJoinEarly';
import { DevelopmentNotice } from '../components/DevelopmentNotice';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function ComingSoon() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-252">
      <Header data-id="element-253" />
      <main data-id="element-254">
        <Hero data-id="element-255" />
        <EarlyAccessForm data-id="element-256" />
        <ServicesPreview data-id="element-257" />
        <WhoItIsFor data-id="element-258" />
        <WhyJoinEarly data-id="element-259" />
        <DevelopmentNotice data-id="element-260" />
        <ContactForm data-id="element-261" />
      </main>
      <Footer data-id="element-262" />
    </div>;
}